import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';

export default function ApplyChoicePage() {
  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <Navbar />
      <main className="pt-32 pb-24 px-6 max-w-[1100px] mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-[#00255a] mb-4">Start Your Study Abroad or Work Abroad Application</h1>
          <p className="text-[#64748b] max-w-xl mx-auto">
            Choose the application that matches your goal — each has its own guided process built around what you need.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <Link
            to="/apply/study"
            className="group bg-white rounded-2xl border-2 border-[#e2e8f0] hover:border-[#00255a] p-10 text-center transition-all shadow-sm hover:shadow-xl"
          >
            <div className="w-20 h-20 rounded-full bg-[#8fb3ff]/20 flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
              <span className="material-symbols-outlined text-4xl text-[#00255a]">school</span>
            </div>
            <h2 className="text-2xl font-bold text-[#00255a] mb-3">Study Abroad and Scholarship Application</h2>
            <p className="text-[#64748b] mb-6">
              Undergraduate and Master's programs, scholarship pathways, and university placements.
            </p>
            <span className="inline-flex items-center gap-2 text-[#00255a] font-bold">
              Start Study Application
              <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">arrow_forward</span>
            </span>
          </Link>

          <Link
            to="/apply/job"
            className="group bg-white rounded-2xl border-2 border-[#e2e8f0] hover:border-[#00255a] p-10 text-center transition-all shadow-sm hover:shadow-xl"
          >
            <div className="w-20 h-20 rounded-full bg-[#ffdad8] flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
              <span className="material-symbols-outlined text-4xl text-[#862026]">work</span>
            </div>
            <h2 className="text-2xl font-bold text-[#00255a] mb-3">Work Placement</h2>
            <p className="text-[#64748b] mb-6">
              Job placements abroad across trades, hospitality, care work, and more.
            </p>
            <span className="inline-flex items-center gap-2 text-[#00255a] font-bold">
              Start Job Application
              <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">arrow_forward</span>
            </span>
          </Link>
        </div>

        <p className="text-center text-[#64748b] mt-12">
          Not sure which fits?{' '}
          <a href="https://wa.me/263775827371" className="text-[#00255a] font-semibold hover:underline">
            Chat with an agent on WhatsApp
          </a>
        </p>
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}
